import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import "./newsevent.css";



import nvq1 from '../../assets/k1.jpg';
import nvq2 from '../../assets/k2.jpg';
import nvq3 from '../../assets/k3.jpg'; 
import nvq4 from '../../assets/k4.jpg';
import nvq5 from '../../assets/k5.jpg';
import nvq6 from '../../assets/k6.jpg';
import nvq7 from '../../assets/k7.jpg';
import nvq8 from '../../assets/k8.jpg';









const sections = [

  {
    title: '',
    images: [ nvq1, nvq2, nvq3, nvq4 ],
  },

    {
   
    images: [ nvq5, nvq6, nvq8 ],
  },

    {
   
    images: [ nvq7 ],
  },


]





const NvqWorkshopKandy = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
        <h1 align="center">NVQ Workshop Kandy - 2026 | Phase 01 </h1>
        <p className="intro-annualmeeting">
        Be Qualified, Be Certified 🎓👀 Phase 01 in Kandy, held on 15th March 2026, 
        was successfully completed. A heartfelt thank you to everyone who participated 
        in our NVQ Level 3 and Level 5 Workshop. Your dedication, enthusiasm, 
        and commitment made this event a great success.
        </p>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};


export default NvqWorkshopKandy